import script from "./CourseHero.vue?vue&type=script&setup=true&lang=ts"
export * from "./CourseHero.vue?vue&type=script&setup=true&lang=ts"

import "./CourseHero.vue?vue&type=style&index=0&id=528dcca4&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src669166032/src/hackingclub-spa/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-528dcca4"]])

export default __exports__